<div class="group-dropdown">
  <div class="group-dropdown__header" (click)="toggleDropdown()">
    <svg
      class="group-dropdown__menu-icon"
      width="14"
      height="13"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#B3BFC9"
        fill-rule="evenodd"
        d="M3.526 11.543a1 1 0 0 0-1.05 1.702c1.256.774 2.54 1.527 3.911 2.18 2.18 1.037 3.935 1.537 4.82 1.75a3.41 3.41 0 0 0 1.59 0c.885-.213 2.64-.713 4.819-1.75a35.044 35.044 0 0 0 3.927-2.19 1 1 0 0 0-1.083-1.682a33.03 33.03 0 0 1-3.704 2.065c-2.03.967-3.649 1.425-4.425 1.61a1.408 1.408 0 0 1-.66 0c-.775-.185-2.393-.643-4.424-1.61-1.274-.606-2.487-1.315-3.72-2.075Zm0 4.73a1 1 0 0 0-1.05 1.702c1.256.774 2.54 1.527 3.911 2.18 2.18 1.037 3.935 1.537 4.82 1.75a3.408 3.408 0 0 0 1.59 0c.885-.213 2.64-.713 4.819-1.75a35.027 35.027 0 0 0 3.927-2.19 1 1 0 1 0-1.083-1.682a33.039 33.039 0 0 1-3.704 2.066c-2.03.966-3.649 1.424-4.425 1.61a1.41 1.41 0 0 1-.66 0c-.775-.186-2.393-.643-4.424-1.61-1.274-.607-2.487-1.316-3.72-2.076ZM12.8 2.095a3.409 3.409 0 0 0-1.59 0c-.885.212-2.64.712-4.819 1.75-1.691.806-2.867 1.507-3.597 1.987a1.703 1.703 0 0 0 0 2.873c.73.48 1.906 1.18 3.597 1.986 2.18 1.038 3.934 1.538 4.82 1.75a3.41 3.41 0 0 0 1.59 0c.885-.212 2.64-.712 4.819-1.75 1.691-.805 2.867-1.506 3.597-1.986a1.703 1.703 0 0 0 0-2.873c-.73-.48-1.906-1.181-3.597-1.987-2.18-1.038-3.934-1.538-4.82-1.75Zm-.465 1.946a1.409 1.409 0 0 0-.66 0c-.775.185-2.393.643-4.424 1.61-.605.288-1.137.56-1.6.811-.564.305-1.025.577-1.392.806l.204.126c.66.402 1.579.916 2.788 1.492 2.03.967 3.649 1.425 4.425 1.61.218.052.441.052.66 0 .775-.186 2.393-.643 4.424-1.61 1.34-.638 2.323-1.2 2.992-1.618a30.033 30.033 0 0 0-2.992-1.617c-2.03-.967-3.649-1.425-4.425-1.61Z"
        clip-rule="evenodd"
      />
    </svg>
    <span class="group-dropdown__label">{{ selectedLabel() }}</span>
  </div>

  @if (isOpen()) {
    <app-group-popup
      [options]="options()"
      [selectedValue]="groupMode()"
      (select)="onSelect($event)"
      (close)="onPopupClose()"
    >
    </app-group-popup>
  }
</div>
